import React from 'react';
import './Footer.module.css'


const Footer = () => {
  return <div>
      <footer className='footer-style'>
        <p style={{color:"black", fontSize:"xx-small"}}>All intellectual property rights, including, but not limited to, copyright and trademarks related to the software, remain the exclusive property of Visualise Fundraising Pty Ltd (ABN 81 647 019 289).</p>       
    </footer>
  </div>;
};

export default Footer;
